export default __webpack_public_path__ + "static/media/environment.a40aea30.jpg";